// removed by extract-text-webpack-plugin
module.exports = {"title":"custom-tab-filters__title___5--84","field-cell":"custom-tab-filters__field-cell___MfaS2","container":"custom-tab-filters__container___3ktm2","payment-type":"custom-tab-filters__payment-type___A3Un8","action":"custom-tab-filters__action___27DQ8","input-field":"custom-tab-filters__input-field___2j0k9","search-field":"custom-tab-filters__search-field___1PM9x","search":"custom-tab-filters__search___3veT1","search-button":"custom-tab-filters__search-button___1SGD3","name":"custom-tab-filters__name___pNM6C"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/documents/custom-tab-filters.scss
// module id = 1320
// module chunks = 0